import CustomerResult from './core/CustomerResult.vue'
import VehicleResult from './core/VehicleResult.vue'
import OfficerResult from './core/OfficerResult.vue'
import StockResult from './core/StockResult.vue'
import UserResult from './core/UserResult.vue'
import CompanyResult from './core/CompanyResult.vue'
import FileResult from './core/FileResult.vue'
import FileFolderResult from './core/FileFolderResult.vue'
import VehicleWorkOrderResult from './module/VehicleWorkOrderResult.vue'
import NoteResult from './module/NoteResult.vue'
import AgendaResult from './module/AgendaResult.vue'
import WeatherResult from './module/WeatherResult.vue'
import MusicTrackResult from './module/MusicTrackResult.vue'
import MusicPlaylistResult from './module/MusicPlaylistResult.vue'

export const RESULT_REGISTRY = {
    CUSTOMERS: CustomerResult,
    VEHICLES: VehicleResult,
    OFFICERS: OfficerResult,
    STOCKS: StockResult,
    USERS: UserResult,
    COMPANIES: CompanyResult,
    FILES: FileResult,
    FILE_FOLDERS: FileFolderResult,
    MODULE_VEHICLE_WORK_ORDER: VehicleWorkOrderResult,
    MODULE_NOTE: NoteResult,
    MODULE_AGENDA: AgendaResult,
    MODULE_WEATHER: WeatherResult,
    MODULE_MUSIC_TRACKS: MusicTrackResult,
    MODULE_MUSIC_PLAYLISTS: MusicPlaylistResult,
}
